import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Table as MuiTable,
  Radio,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  styled
} from '@mui/material';
import { dateFormatter, getReccurssiveObjectKeys } from '../../../../../utils';
import { Checkbox } from '../../../../../components';
import AddIcon from '@mui/icons-material/Add';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  padding: theme.spacing(0.9),
  whiteSpace: 'nowrap',
  fontSize: '16px',
  fontWeight: 550
}));

export const DietManagementTable = ({
  data,
  columns,
  onRowClick,
  containerSX,
  sx,
  showOk,
  showAddDetails,
  onClickEditRow,
  handleRowSelect,
  isSelected,
  selectedRows
}) => {
  console.log(selectedRows, 'TABLE SELECTED ROW ');
  return (
    <TableContainer sx={{ maxHeight: '259px', overflowY: 'auto', ...containerSX }}>
      <MuiTable sx={sx}>
        <TableHead>
          <TableRow sx={{ backgroundColor: 'lightblue' }}>
            {showOk && <StyledTableCell key="ok-cell" sx={{ fontWeight: 'bold' }}></StyledTableCell>}
            <StyledTableCell key="sr.no.-cell" sx={{ fontWeight: 'bold' }}>
              Sr. No.
            </StyledTableCell>

            {columns.map((column, index) => (
              <StyledTableCell sx={{ fontWeight: 'bold' }} key={`header-cell-${index}`}>
                {column.header}
              </StyledTableCell>
            ))}
            {showAddDetails && (
              <StyledTableCell key="edit-cell" sx={{ fontWeight: 'bold' }}>
                Add Diet
              </StyledTableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, rowIndex) => (
            <TableRow
              {...(onRowClick && {
                onClick: () => {
                  onRowClick(row);
                }
              })}
              sx={{
                backgroundColor: rowIndex % 2 ? 'grey.200' : 'none',
                cursor: onRowClick ? 'pointer' : 'default',
                '&:hover': {
                  backgroundColor: 'grey.300'
                },
                transition: 'all 0.1s ease-in',
                '&:hover': { backgroundColor: 'grey.300' }
              }}
              key={rowIndex}
            >
              {showOk && (
                <StyledTableCell>
                  <Radio
                    sx={{
                      transform: 'scale(0.8)',
                      padding: '0'
                    }}
                    name={row?._id}
                    disabled={false}
                    checked={isSelected(row, 'ok')}
                    onChange={() => handleRowSelect(row, 'ok')}
                    size="large"
                  />
                </StyledTableCell>
              )}
              <StyledTableCell key={`${row._id}-cell0`}>{rowIndex + 1}</StyledTableCell>
              {columns.map(({ header, accessor, sx }, colIndex) => (
                <StyledTableCell sx={sx} key={`${row._id}-cell${colIndex + 1}`}>
                  {typeof accessor === 'function' ? (
                    accessor(row) || '0'
                  ) : (
                    <>
                      {header === 'Created At' || header === 'Date'
                        ? dateFormatter(getReccurssiveObjectKeys(row, accessor)) || '-'
                        : getReccurssiveObjectKeys(row, accessor) || '0'}
                    </>
                  )}
                </StyledTableCell>
              ))}
        
                <StyledTableCell key={`${row._id}-edit-button-cell`}>
                {selectedRows?.some((selectedRow) => selectedRow._id === row._id) && showAddDetails && (
                  <AddIcon
                    onClick={() => onClickEditRow(row)}
                    type="submit"
                    sx={{
                      fontSize: 22,
                      color: 'green',
                      cursor: 'pointer',
                      strokeWidth: 4
                    }}
                  />
                  )}
                </StyledTableCell>
        
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};
